import { render, staticRenderFns } from "./SvgFlag.vue?vue&type=template&id=10d45422"
import script from "./SvgFlag.vue?vue&type=script&lang=js"
export * from "./SvgFlag.vue?vue&type=script&lang=js"
import style0 from "./SvgFlag.vue?vue&type=style&index=0&id=10d45422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports